import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser } from '../../../reducers'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import FormClient from '../../containers/FormClient'
import { db } from '../../../config/Fire'
import * as Constants from '../../../constants'
import LoadingPage from '../../components/LoadingPage'
import './styles.css'

const DetailsClients = props => {
    const [updatingClient, setUpdatingClient] = useState(false)
    const [detailsClient, setDetailsClient] = useState(null)

    useEffect(() => {
        if (props.clientToEdit) {
            setDetailsClient(props.clientToEdit)
        }
    }, [props.clientToEdit])

    const updateClient = async prop => {
        if (prop && detailsClient && detailsClient.id) {
            try {
                const clientToUpdate = { ...prop }
                setUpdatingClient(true)
                await db.ref(Constants.MAIN_NODES.USERS + '/' + detailsClient.id).update(clientToUpdate)
                message.success('El cliente se actualizó exitósamente')
                setUpdatingClient(false)
                props.onUpdateClient(clientToUpdate)
            } catch (err) {
                console.log(err)
                message.error('Se produjo un error al actualizar el cliente. Por favor, vuelva a intentarlo')
                setUpdatingClient(false)
            }
        }
    }

    return (
        <Grid className="newOutsourcingCont">
            {
                detailsClient ?
                    <div>
                        <Row center="xs">
                            <Col xs={12}>
                                <h2>Edición - Cliente</h2>
                            </Col>
                        </Row>
                        <Divider/>
                        <Row center="xs">
                            <Col xs={12}>
                                <FormClient
                                    isEditing={true}
                                    clientToEdit={detailsClient}
                                    onSubmitClient={updateClient}
                                    loading={updatingClient}
                                />
                            </Col>
                        </Row>
                        <Row center="xs">
                            <Col xs={6}>
                                <Button onClick={() => props.onBack(false, null)} loading={updatingClient}>
                                    Salir
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    :
                    <LoadingPage/>
            }
        </Grid>
    )
}

DetailsClients.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(DetailsClients))